/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Lineas from "./Componentes/Home_Lineas";
import Home_Oferta_Edutavita from "./Componentes/Home_Oferta_Edutavita";
import Home_Somos from "./Componentes/Home_Somos";
import Home_Buena_Educacion from "./Componentes/Home_Buena_Educacion";
import Home_Perspectiva from "./Componentes/Home_Perspectiva";
import Home_Perspectiva_Escuelas from "./Componentes/Home_Perspectiva_Escuelas";
import Home_Programas from "./Componentes/Home_Programas";
import Home_PorQue_Elejirnos from "./Componentes/Home_PorQue_Elejirnos";
import Home_Banner from "./Componentes/Home_Banner";
import Home_Proceso_Adminision from "./Componentes/Home_Proceso_Adminision";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import {SECCIONES} from "../../Constantes";


const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Lineas/>
            </Grid>


            <Grid id={'catalogo'} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 10}}>
                <Home_Oferta_Edutavita/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Somos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Buena_Educacion/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Home_Perspectiva/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 24}}>
                <Home_Perspectiva_Escuelas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14}}>
                <Home_Programas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14}}>
                <Home_PorQue_Elejirnos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 16}}>
                <Home_Banner/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                <Home_Proceso_Adminision/>
            </Grid>

            <Grid id={SECCIONES[2]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 18}}>
                <Home_Testimonios/>
            </Grid>

            {/*}

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Testimonios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Nosotros_Home/>
            </Grid>*/}


        </Grid>
    )

}
export default Seccion_Home    